import React, { memo } from 'react'

import { useSuggestionsShallowSelector } from 'components/WorkspaceEditor/SuggestionStore'
import { CardList } from '.'
import { useTrackedChangesPanelStyles } from '../styles'
import { FilterSeparator } from './TrackChangeCards/FilterSeparator'

/**
 * TrackChangeSideBar component renders the sidebar for track changes,
 * displaying a list of tracked changes and a filter separator.
 * It uses the useSuggestionsStore to get the trackChangesData.
 */
export const TrackChangeSideBar = memo(() => {
    const { editorContainerSidebar } = useTrackedChangesPanelStyles()
    const { trackChangesData } = useSuggestionsShallowSelector((state) => ({
        trackChangesData: state.trackChangesData,
    }))

    return (
        <div
            className={editorContainerSidebar}
            id="editorContainerSidebarId"
            data-testid="track-Changes-SideBar"
        >
            <FilterSeparator />
            <CardList trackChangesData={trackChangesData} />
        </div>
    )
})
